import shop from '../../api/shop'
import * as types from '../mutation-types'

// initial state
const state = {
	all: []
}

// getters
const getters = {
	allProducts: state => state.all
}

// actions
const actions = {
	getAllProducts({commit}) {
		shop.getProducts(products => {
			commit(types.RECEIVE_PRODUCTS, {products})
		})
	},
	getAllProducts1(context) {
		shop.getProducts1(products => {
			console.log(products);
			context.commit(types.RECEIVE_PRODUCTS, products);
		})
	}
}

// mutations
const mutations = {
	[types.RECEIVE_PRODUCTS](state, products) {
		console.log(products);
		state.all = products
	},

	[types.ADD_TO_CART](state, {id}) {
		// state.all.find(product => product.id === id).inventory--

		state.all.find(product => product.id === id).inventory--
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js